var webooker = webooker || {};

webooker.AjaxForm = function (loadingPanelName, popupMessageName, resultMessageDivID, formID, onComplete, onSuccess, onError) {
    var _dXloadingPanelName = loadingPanelName,
        _dXpopupMessageName = popupMessageName,
        _resultMessageDivID = resultMessageDivID,
        _formID = formID,
        _onComplete = onComplete,
        _onSuccess = onSuccess,
        _onError = onError,

        getForm = function () {
            return $('#' + _formID);
        },

        getLoadingPanel = function () {
            return window[_dXloadingPanelName];
        },

        getPopUpMessage = function () {
            return window[_dXpopupMessageName];
        },

        getValidationSummary = function () {
            return getForm().find(".validation-summary-errors");
        },

        rebindValidation = function () {
            if ($.validator) {
                var form = getForm();

                form.removeData("validator");
                $.validator.unobtrusive.parse(form);
            }
        },

        showSuccessMessage = function (successDiv) {
            var dXpopupMessage = getPopUpMessage();
            if (dXpopupMessage) {
                dXpopupMessage.SetContentHtml('<div class="popup-message">' + successDiv.val() + '</div>');
                dXpopupMessage.Show();
                setTimeout(function () {
                    dXpopupMessage.Hide();
                }, 1500)
            }
        },

    // Public methods

        onAjaxBegin = function (xhr) {
            getLoadingPanel().Show();
        },

        onAjaxSuccess = function (data, status, xhr) {
            getLoadingPanel().Hide();

            var successDiv = $('#' + _resultMessageDivID);
            if (successDiv.val() !== 'false') {

                showSuccessMessage(successDiv);

                if (_onSuccess) {
                    _onSuccess();
                }
            } else {
                if (_onError) {
                    _onError();
                }
            }
        },

        onAjaxComplete = function (xhr, status) {
            getLoadingPanel().Hide();
            rebindValidation();

            if (_onComplete) {
                _onComplete();
            }
        },

        onAjaxFailure = function (xhr, status, error) {
            alert(error);
        },

        submit = function () {
            getLoadingPanel().Hide();
            var popUpMessage = getPopUpMessage();
            if (popUpMessage) {
                popUpMessage.Hide();
            }
            rebindValidation();

            // TODO: Remove me after transition to DevExpress 2012 2.5 or higher
            // [DataType(DataType.EmailAddress)] does not work properly atm.
            //var validationResult = ASPxClientEdit.ValidateEditorsInContainerById(_formID);

            var form = getForm();
            form.validate();
            if (form.valid() /*&& validationResult*/) {
                getValidationSummary().hide();
                form.submit();
            } else {
                getValidationSummary().show();
            }
        };
    return {
        onAjaxBegin: onAjaxBegin,
        onAjaxSuccess: onAjaxSuccess,
        onAjaxComplete: onAjaxComplete,
        onAjaxFailure: onAjaxFailure,
        submit: submit
    };
};